import React, { Component } from 'react'
import Location from 'components/Location'
import Session from 'components/Session'
import { authenticate } from 'redux-simple-auth'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { hasAuthorizationParams } from 'utils/auth'
import { Loader } from 'stylist'
import { Redirect } from 'react-router-dom'
import styled from '@emotion/styled'
import withQueryParams from 'components/withQueryParams'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

class RouteLoginSetToken extends Component {
  componentDidMount() {
    const { authenticate, query } = this.props
    const token = JSON.parse(query.get('token'))

    authenticate('oauth2-implicit-grant', token)
  }

  render() {
    const { query } = this.props

    return (
      <Session
        render={({ isAuthenticated, hasFailedAuth }) =>
          hasFailedAuth ? (
            <Redirect to="/login" />
          ) : isAuthenticated && hasAuthorizationParams(query) ? (
            <Container>
              <Loader size="lg" />
              <Location
                to={`${
                  process.env.REACT_APP_API_HOST
                }/oauth/authorize?${query}`}
                replace
              />
            </Container>
          ) : isAuthenticated ? (
            <Redirect to="/" />
          ) : (
            <Container>
              <Loader size="lg" />
            </Container>
          )
        }
      />
    )
  }
}

export default compose(connect(null, { authenticate }), withQueryParams)(
  RouteLoginSetToken
)



// WEBPACK FOOTER //
// ./src/routes/login/set-token.js